import { SxProps } from '@mui/material'

interface BannerDropdownListStyles {
  container: SxProps
  headingWrapper: SxProps
  heading: SxProps
  list: SxProps
  listItemHeading: SxProps
  listItemDesc: SxProps
  divider: SxProps
}

export const bannerDropdownListStyles: BannerDropdownListStyles = {
  container: {
    '&:last-child': {
      '.divider': {
        display: 'none',
      },
    },
  },
  headingWrapper: {
    px: 2,
    py: 1,
    position: 'sticky',
    top: 0,
    backgroundColor: 'background.default',
    zIndex: 1,
  },
  heading: {
    typography: 'textMdSemibold',
    color: 'text.primary900',
  },
  list: {
    p: 0,
  },
  listItemHeading: {
    width: '100%',
    typography: 'textSmMedium',
    color: 'text.primary900',
  },
  listItemDesc: {
    width: '100%',
    typography: 'textSm',
    color: 'text.secondary700',
  },
  divider: {
    width: '100%',
    height: '1px',
    backgroundColor: 'border.secondary',
    my: 0.5,
  },
}
